// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    api,
    IPaginateApiResponse,
} from 'common/api/resources/Response';
import { QueryBuilder } from 'common/api/resources/Request/QueryBuilder';
import { IPaginated } from 'common/api/resources/Request/request';
import {
    IHighAvailabilityActivityRequest,
    IHighAvailabilityActivity,
    IHighAvailabilityActivityEntity,
    IHighAvailabilityActivityMoveBackRequest,
} from 'common/api/resources/HighAvailability';

export const highAvailability = {
    activities: {
        list: (params?: IHighAvailabilityActivityRequest) => api.get<IPaginateApiResponse<IHighAvailabilityActivity[]>>(
            'high_availability_activities', {
                params: new QueryBuilder(params).build(),
            }),
    },
    entities: {
        list: (activityId: number, params?: IPaginated) => api.get<IPaginateApiResponse<IHighAvailabilityActivityEntity[]>>(
            `high_availability_activities/${activityId}/entities`, {
                params: new QueryBuilder(params).build(),
            }),
        moveBack: (request: IHighAvailabilityActivityMoveBackRequest) => api.post<{ data: number[] }>(
            'high_availability_activity_entities/move_back',
            request
        ),
    },
};
